import React, { Component } from 'react';

import { withFirebase } from '../Firebase';
import Button from '@material-ui/core/Button';
import CardContent from '@material-ui/core/CardContent';

import Card from '@material-ui/core/Card';
import TextField from '@material-ui/core/TextField';

const INITIAL_STATE = {
  passwordOne: '',
  passwordTwo: '',
  error: null,
  confirmedReset: false
};

class PasswordChangeForm extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  onSubmit = event => {
    const { passwordOne } = this.state;
    this.setState({confirmedReset: false });
    this.props.firebase
      .doPasswordUpdate(passwordOne)
      .then(() => {
        this.setState({ ...INITIAL_STATE });
        this.setState({confirmedReset: true });
      })
      .catch(error => {
        this.setState({ error });
      });

    event.preventDefault();
  };

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    const { passwordOne, passwordTwo, error } = this.state;

    const isInvalid =
      passwordOne !== passwordTwo || passwordOne === '';
    
    const isPasswordMissMatch =
      passwordOne !== passwordTwo;  

    return (
      

      <div className="Container-box">
      <Card className="Card">
        <CardContent>
        { this.state.confirmedReset && <p style={{ 'color': '#3e51b5' }} > Password has been reset. </p>}
          <form className="Form-Container" onSubmit={this.onSubmit}>
            <TextField
              className="Text-Field"
              type="password"
              name="passwordOne"
              label="New password"
              value={passwordOne}
              onChange={this.onChange}
              required
              margin="normal"
            />

            <TextField
              className="Text-Field"
              type="password"
              name="passwordTwo"
              label="Confirm new password"
              value={passwordTwo}
              onChange={this.onChange}
              required
              margin="normal"
            />
            <Button variant="contained" size="medium" color="primary" disabled={isInvalid} className="Submit-Button" type="submit">
              Reset My Password
            </Button>
            { isPasswordMissMatch && <p style={{ 'color': '#3e51b5' }}> Please confirm password </p>}
            {error && <p style={{ 'color': '#3e51b5' }}>{error.message}</p>}
          </form>
        </CardContent>
      </Card>
    </div>
    );
  }
}

export default withFirebase(PasswordChangeForm);
